import { GoogleLogin } from '@/components';
import { MasterTranslation, type SignUpSource } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { IUserInfo } from '@/interfaces';
import type { FC } from 'react';

interface LoginPMTButtonProps {
  newsletterOptIn: boolean;
  signUpSource: SignUpSource;
  shouldReloadAfterSuccess: boolean;
  customHandleClick: () => void;
  customHandleSuccess: (userInfo: IUserInfo) => void;
}

export const LoginPMTButton: FC<LoginPMTButtonProps> = (props) => {
  const { t } = useGlobalState();

  return <GoogleLogin {...props} buttonText={t(MasterTranslation.ContinueWithGoogle)} />;
};
